/* ==========================================================================
  Theme's main.js
  define JS functions here as per theme feature requirements.
========================================================================== */

//'use strict';
/* global fitvids, cssVars */

/**
 * Init responsive videos
 */
//fitvids();

/**
 * Init CSS vars ponyfill
 */
//cssVars({});

document.addEventListener('DOMContentLoaded', function () {
   const productWrappers = document.querySelectorAll('.product-image-wrapper.ishover');
   productWrappers.forEach(wrapper => {
      const video = wrapper.querySelector('.product-hover-video');
      const imageContainer = wrapper.querySelector('.image-container');
      var imageOriginal = wrapper.querySelector('.oriimg');
      if(!imageOriginal){
        imageOriginal=wrapper.querySelector('.attachment-woocommerce_thumbnail');
      }
      if (video) {
         wrapper.addEventListener('mouseover', () => {
            video.style.display = 'block';
            video.play();
         });
         wrapper.addEventListener('mouseout', () => {
            video.style.display = 'none';
            video.pause();
            video.currentTime = 0;
         });
      }
      if (imageContainer) {
         wrapper.addEventListener('mouseover', () => {
            imageContainer.style.display = 'block';
            imageOriginal.style.opacity = '0';            
         });
         wrapper.addEventListener('mouseout', () => {
            imageContainer.style.display = 'none';
            imageOriginal.style.opacity = '1';           
         });
      }
   });
});

( function ( $ ) {      
    $(document).on( 'click', 'button.plus, button.minus', function() { 
        var qty = $( this ).closest( '.quantity' ).find( '.qty' );
        var val   = parseFloat(qty.val());
        var max = parseFloat(qty.attr( 'max' ));
        var min = parseFloat(qty.attr( 'min' ));
        var step = parseFloat(qty.attr( 'step' ));
        if ( $( this ).is( '.plus' ) ) {
            if ( max && ( max <= val ) ) {
                qty.val( max );
            } else {
                qty.val( val + step );
            }
            qty.change();
        } else {
            if ( min && ( min >= val ) ) {
                qty.val( min );
            } else if ( val > 1 ) {
                qty.val( val - step );
            }
            qty.change();
        }
    });

    $(document).on('click','.show-review-popup',function(e){
        e.preventDefault();
        $('body').addClass('open-review-popup');
    });

    $(document).on('click','.close-reviews-popup',function(e){
        e.preventDefault();
        $('body').removeClass('open-review-popup');
    });

    /**Code to function Quick buy on shop loop*/
    $('.quick-buy-button').on('click', function(e) {
        e.preventDefault();
        var productId = $(this).data('product-id');

        $.ajax({
            url: wc_add_to_cart_params.ajax_url,
            type: 'POST',
            data: {
                action: 'get_quick_buy_product_info',
                product_id: productId
            },
            success: function(response) {
                $('#quick-buy-product-info').html(response);
                $('#quick-buy-popup').show();
            }
        });
    });

    $('#quick-buy-form').on('submit', function(e) {
        e.preventDefault();
        var formData = $(this).serialize()+ '&action=quick_buy_add_to_cart';

        $.ajax({
            url: wc_add_to_cart_params.ajax_url,
            type: 'POST',
            data: formData,
            dataType: 'json',
            success: function(response) {
                if(response.status==='success'){
                    $('#quick-buy-popup').hide();
                    window.location.href = response.checkout_url;
                }
                else{
                    alert(response.errorMsg)
                }
            }
        });
    });

    $(document).on('click', function(event) {
        if (!$(event.target).closest('#quick-buy-popup-content').length) {
            $('#quick-buy-popup').hide();
        }
    });


    /**Code to function custom add to cart on shop loop*/
    $('.ssshop-addto-cart-button').on('click', function(e) {
        e.preventDefault();
        var productId = $(this).data('product-id');
        $.ajax({
            url: wc_add_to_cart_params.ajax_url,
            type: 'POST',
            data: {
                action: 'get_addtocart_product_info',
                product_id: productId
            },
            success: function(response) {
                $('#sshopaddto-cart-product-info').html(response);
                $('#sshopaddto-cart-popup').show();
            }
        });
    });

    $('#sshopaddto-add-to-cart-form').on('submit', function(e) {
        e.preventDefault();
        var formData = $(this).serialize()+ '&action=ssshop_add_to_cart';

        $.ajax({
            url: wc_add_to_cart_params.ajax_url,
            type: 'POST',
            data: formData,
            dataType: 'json',
            success: function(response) {
                if(response.status==='success'){
                    $('#sshopaddto-cart-popup').hide();
                }
                else{
                    alert(response.errorMsg)
                }
            }
        });
    });

    $(document).on('click', function(event) {
        if (!$(event.target).closest('#sshopaddto-cart-popup-content').length) {
            $('#sshopaddto-cart-popup').hide();
        }
    });

    $('.size-chart-popup-trigger').on('click', function(e) {
        e.preventDefault();
        $('#size-chart-popup').addClass('show').show();
        $('body').addClass('overflow');

    });

    $(document).on('click', '.size-chart-popup-close', function(e) {
        e.preventDefault();
        $('#size-chart-popup').removeClass('show').hide();
        $('body').removeClass('overflow');
    });

    $(window).scroll(function(){
        if ($(this).scrollTop() > 200) {
           $('.header-section').addClass('active');
        } else {
           $('.header-section').removeClass('active');
        }
    });
    $('.share-trigger').on('click', function(e) {
        e.preventDefault();
        var popupurl=$(this).attr('href');
        $(popupurl).addClass('show').show();
    });

    $(document).on('click', '.share-popup-close', function(e) {
        e.preventDefault();
        var popupurl=$(this).attr('href');
        $(popupurl).removeClass('show').hide();
    });

    $('#nlcta').on('click', function(e) {
        e.preventDefault();
        var mail = $('#nlemail').val();
        if (mail === '') {
            $('.footer-form').addClass('error');
        }
        else if (IsEmail(mail) === false) {
            $('.footer-form').addClass('error')
        }
        else{
           
            $.ajax({
                type: "POST",
                url: ssAjax.ajaxurl,
                data: { nonce: ssAjax.nonce, mail:mail, action: 'pushnewsltter' },
                dataType: 'html',
                success: function (response) {
                //  console.warn(response);
                 if(response.TotalApplicationBehaviour != ''){
                    $(".sucessx").fadeIn();
                    setTimeout(function(){ 
                        $(".sucessx").fadeOut()
                     }, 3000);
                 }
                }
            });
            $('.footer-form').removeClass('error')
        }
    });

    function IsEmail(mail) {
        const regex =
/^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        if (!regex.test(mail)) {
            return false;
        }
        else {
            return true;
        }
    }
   
    jQuery(document).ready(function($) {
        function fadeOutWooCommerceErrors() {
            if ($('.woocommerce-error').length) {
                // Set a timeout to fade out the error messages after 5 seconds
                setTimeout(function() {
                    $('.woocommerce-error').fadeOut('slow');
                }, 4000); // 5000 milliseconds = 5 seconds
            }
        }
    
        // Initial check on page load
        fadeOutWooCommerceErrors();
    
        // Check again after any AJAX request completes
        $(document).ajaxComplete(function() {
            fadeOutWooCommerceErrors();
        });
    });
      $('.header-icon ul li.login-icon .setlogin').click(function(event) {
        $('.header-icon ul li.login-icon').addClass('hover');
        event.stopPropagation(); // Prevent the body click event from triggering
    });
    // Remove class on body click
    $('body').click(function() {
        $('.header-icon ul li.login-icon').removeClass('hover');
    });
    // Stop propagation for clicks inside the login-icon to prevent removing the class immediately
    $('.header-icon ul li.login-icon').click(function(event) {
        event.stopPropagation();
    });
    
    
})( jQuery );
